import { useMemo } from 'react';

import { useEndorsementsLayoutPageData } from '#src/app/pages/starterDashboardEndorsements/pageContext';

export function useEndorsementsLayoutPageStateValue() {
	const {
		data: { petition, viewer },
	} = useEndorsementsLayoutPageData();

	return useMemo(
		() => ({
			petition,
			ownPetition: petition.user.id === viewer.user?.id,
		}),
		[petition, viewer],
	);
}
